module.exports = __webpack_public_path__ + "static/mini2-e629e5d84c97b5d952f7b01aeff3cb1d.jpeg";